import DisabilityIcon from '../../Icons/disability.svg';

const Disability = (props) => {
  return (
    <div className="disability-icon">
      <img src={DisabilityIcon}></img>
    </div>
  );
};

export default Disability;
